import { defineMessages } from 'react-intl';

export const i18n: {
	repositoryLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	repositoryLabel: {
		id: 'search-page.filters.names.repository',
		defaultMessage: 'Repository',
		description: 'Label for filtering search results by repository name',
	},
	noOptions: {
		id: 'search-page.filters.names.repository.no-options',
		defaultMessage: 'No repositories available',
		description:
			'Label shown in the repository filter dropdown when no repository options are available',
	},
});
